import { Component, computed, inject, Input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { AuthService, UserDetailsStateService } from '@bn/auth/services';
import { AccountStore, UserStore } from '@bn/auth/stores';
import { UserProfileComponent } from '@bn/layout/user-profile/user-profile.component';
import { AppRoutes } from '@bn/primitives';

import { NotificationsComponent } from '../notifications/notifications.component';
import { buildUserProfileMenuItems } from '../user-profile/user-profile.config';

@Component({
  selector: 'bn-dashboard-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss'],
  imports: [RouterLink, RouterLinkActive, FaIconComponent, NotificationsComponent, UserProfileComponent],
})
export class MobileHeaderComponent {
  readonly #authService = inject(AuthService);
  readonly #accountStore = inject(AccountStore);
  readonly #userStore = inject(UserStore);
  readonly #userDetails = toSignal(inject(UserDetailsStateService).getUserDetails());

  readonly accountRoute = `/${AppRoutes.Account}`;
  readonly billingRoute = `/${AppRoutes.Account}/${AppRoutes.Billing}`;
  readonly billingBalance = computed(() => this.#accountStore.billingOverview()?.AvailableBalance);
  readonly userProfileMenuItems = computed(() => buildUserProfileMenuItems(this.#userDetails(), !!this.#authService.authStoreValue?.partner));
  readonly userEmail = computed(() => this.#userDetails()?.Email ?? '');
  readonly showBilling = computed(() => {
    const roles = this.#userDetails()?.Roles ?? [];

    if (this.#userStore.hidePricing()) return false;

    return roles.includes('User') || roles.includes('SubuserBilling');
  });
  readonly userFullName = computed(() => {
    const u = this.#userDetails();

    return u ? `${u.FirstName ?? ''} ${u.LastName ?? ''}`.trim() : '';
  });

  @Input()
  public isMobileMenuOpened = false;

  public readonly toggleMenu = output<boolean>();

  public onToggleMenu(): void {
    this.toggleMenu.emit(!this.isMobileMenuOpened);
  }

  public onLogout(): void {
    this.#authService.logout();
  }
}
